
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learning-group",
      function () {
        return require("private-next-pages/learning-group/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learning-group"])
      });
    }
  